<script setup lang="ts">
import { ref, computed } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { authStore } from "@/store/auth";
import WorkTypeRadioGroup from "@/components/molecules/orders/WorkTypeRadioGroup.vue";

defineProps({
  show: {
    type: Boolean,
    required: true,
    default: false
  }
});

const emit = defineEmits(["submit"]);

const workerServiceId = ref<number | null>(null);

const product = computed(() => authStore.product);
const workerServiceOptions = computed(() =>
  authStore.product.workerServices.map(ws => ({
    value: ws.id,
    text: ws.displayName
  }))
);

const submit = () => emit("submit", workerServiceId.value);
</script>
<template>
  <BModal
    :modelValue="show"
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    centered
  >
    <CustomValidationObserver
      tag="div"
      v-slot="{ handleSubmit }"
      :initialValues="{ workerServiceId }"
      ref="vObserver"
    >
      <p class="mb-3 text-size-14">
        『{{
          product.name
        }}』では以下の業務カテゴリのお仕事を探すことができます。
      </p>

      <div>
        <ValidationField
          v-slot="validationState"
          label="業務"
          name="workerServiceId"
          rules="required"
          v-model="workerServiceId"
        >
          <WorkTypeRadioGroup
            v-model:value="workerServiceId"
            :validationState="validationState"
            name="workerServiceId"
            :options="workerServiceOptions"
          />
        </ValidationField>
      </div>

      <p class="mt-3 mb-3 text-size-14">
        業務カテゴリを設定することで、対象のお仕事を検索したり、資格登録をしたりすることができるようになります。
      </p>
      <AppButton block @click="handleSubmit(submit)">設定する</AppButton>
    </CustomValidationObserver>
  </BModal>
</template>
